import { render, staticRenderFns } from "./quiz.page.vue?vue&type=template&id=74f8f80a&scoped=true&"
import script from "./quiz.page.js?vue&type=script&lang=js&"
export * from "./quiz.page.js?vue&type=script&lang=js&"
import style0 from "./quiz.page.scss?vue&type=style&index=0&id=74f8f80a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f8f80a",
  null
  
)

export default component.exports